const SUBSCRIBER_TYPE = require('../../deliverysaver/delivery-saver.constants').SUBSCRIBER_TYPE;

function checkAllowToSubscribeDeliverySaver($state, $stateParams, deliverySaverService, shopperService) {

    return deliverySaverService.getEligibility()
        .then((response) => {
            if (!response.IsEligibleForDeliverySaver) {
                // This page will explain eligibility issues
                $state.go('shop.deliveryunlimited');
            } else {
                const selectedSubscriberType = $stateParams.subscriberType;

                switch (selectedSubscriberType) {
                    case SUBSCRIBER_TYPE.PERSONAL:
                        if (shopperService.isBusinessShopper()) {
                            $state.go('shop.deliveryunlimited.planselection', {
                                personalPlansNotEligible: true,
                            });
                        }
                        break;
                    case SUBSCRIBER_TYPE.BUSINESS:
                        if (!shopperService.isBusinessShopper()) {
                            $state.go('shop.deliveryunlimited.planselection', {
                                businessPlansNotEligible: true,
                            });
                        }
                        break;
                    case SUBSCRIBER_TYPE.SENIOR:
                        if (!response.IsEligibleForSeniorPlan) {
                            $state.go('shop.deliveryunlimited.planselection', {
                                seniorPlansNotEligible: true,
                            });
                        }
                        break;
                    default:
                        $state.go('shop.deliveryunlimited.planselection', {});
                }
            }
        });
}

module.exports = {
    checkAllowToSubscribeDeliverySaver,
};




// WEBPACK FOOTER //
// ./src/configuration/routes/deliverysaver-handler.js